import { render, staticRenderFns } from "./showindexNav.vue?vue&type=template&id=6a04988d&"
import script from "./showindexNav.vue?vue&type=script&lang=js&"
export * from "./showindexNav.vue?vue&type=script&lang=js&"
import style0 from "./showindexNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/index/showindexNav.vue
// module id = null
// module chunks = 